<template>
<div class="login">
  <div class="form">
    <div class="header">
      <b>{{ $t('login.password_reset.heading')}}</b>
    </div>
    <div class="body">
      <p class="helper">
        {{ $t('login.password_reset.set_new')}}
      </p>
      <div class="form-item">
        <label for="">
          {{ $t('login.password')}}
        </label><br>
        <input type="password" name="password" class="text-input" v-model="form.password">
      </div>
      <div class="form-item">
        <label for="">
          {{ $t('login.password_repeat')}}
        </label><br>
        <input type="password" name="password-confirm" class="text-input" v-model="form.password_confirmation">
      </div>
      <div class="form-item">
        <button class="btn btn-block" @click='resetPass'>{{ $t('login.update')}}</button>
      </div>
    </div>
    <div class="footer">
      <a href="/login"><i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>{{ $t('login.back')}}</a>
    </div>
  </div>
</div>
</template>

<script>
import api from '../api'

export default {
  data () {
    return {
      form: {
        token: null,
        email: null,
        password: '',
        password_confirmation: ''
      }
    }
  },
  created () {
    this.form.token = this.$route.params.token
    this.form.email = this.$route.params.email
  },
  mounted () {
    this.$Progress.finish()
  },
  methods: {
    resetPass () {
      var self = this
      this.$Progress.set(25)
      api.postReset(self.form)
        .then(
          () => {
            self.$router.push('/login')
            this.$Progress.finish()
          }
        ).catch(
          () => {
            this.$Progress.fail()
            alert('Something went wrong.')
          }
        )
    }
  }
}
</script>
<style scoped lang="stylus" src="../styles/_Login.styl"/>



// WEBPACK FOOTER //
// src/components/PasswordChange.vue